export const newAndEditProduct = {
	titles: {
		edit: "Editar Producto",
		add: "Agregar Producto",
		productDetails: "Detalles del producto",
		hasFiscalData: "Datos fiscales",
		hasMountableProduct: "Producto montable",
		hasProductRule: "Ficha Técnica",
		hasProportionalProduct: "Producto en g/ml",
		downloadQRCodeToSell: "Descargar QR code para venta",
		releaseValue: "Precio de suelta",
	},
	duplicateButton: "Duplicar",
	errors: {
		productFeature: "La funcionalidad {{wrongFeature}} no está llenada correctamente.",
		productFeatures:
			"Las funcionalidades {{wrongFeatures}} no están llenadas correctamente.",
		requiredField: "Este campo es obligatorio",
		proportionalQuantity: "La cantidad debe ser mayor que 0",
		abvQuantity: "El porcentaje debe ser menor que 100%",
		name: "Use solo caracteres válidos",
		categoryId: "Elija o cree una categoría",
		wrongSection: "La Etapa {{wrongStep}} no está llenada correctamente.",
		wrongSections: "Las Etapas {{wrongSteps}} no están llenadas correctamente.",
		productRules: "Existen insumos no llenados",
		productRulesNotValidCount: "El valor de pérdida no puede ser mayor que la cantidad",
		newCategory: "Usted creará una nueva categoría",
		length: "Máx. {{length}} caracteres",
		fiscalCode: "Solo números, puntos y letras",
		conversionRule: "Los valores de la regla de conversión deben ser llenados",
	},
	forms: {
		details: {
			name: "Nombre del Producto",
			type: "Tipo del Producto",
			selectType: "Seleccione un tipo de producto",
			measurement: "Inventario controlado por",
			category: "Categoría",
			menuCategory: "Categoría del Menú",
			priceIn: "Precio en",
			price: "Precio",
			variablePrice: "Precio variable",
			picture: "Foto",
			description: "Descripción",
			hasAlcohol: "Contiene Alcohol",
			hasFiscalData: "Datos fiscales",
			fiscalDataMessage: "El código del producto será generado automáticamente",
			hasMountableProduct: "Producto montable",
			isStockable: "Producto almacenable",
			hasProductRule: "Ficha Técnica",
			hasProportionalProduct: "Producto en g/ml",
			isHiddenFromApp: "No mostrar producto en la aplicación ZigApp",
			syncWithBeerIntegration: "Sincronizar con {{integration}}",
			beerBrand: "Marca",
			beerStyle: "Estilo de la bebida",
			beerABV: "ABV - Contenido alcohólico",
			beerIbu: "IBU - Unidades Internacionales de Amargor",
			beerIntegrationDisabledWarning:
				"No es posible desactivar esta función con 'Sincronizar con {{integration}}' activa",
			beerIntegrationEnabledWarning:
				"No es posible activar esta función con 'Sincronizar con {{integration}}' activa",
			beerIntegrationPlaceFeatureWarning:
				"Función deshabilitada. Contacte al soporte para activarla en el admin.",
			productReturn: "Producto retornable",
			isSupplyToggle: "Insumo",
			conversionRule: {
				unit: "Unidad",
				amount: "Cantidad",
				unitMeansure: "Unidad de medida",
				placeholderSelect: "Seleccione",
				convertionName: "Regla de conversión",
				title: {
					unitDefault: "Unidad de medida estándar",
					unitConvertion: "Regla de conversión",
				},
				field: { quantity: "Cantidad", unitMeansure: "Unidad de medida" },
				resumeDescription: "equivale a:",
				infoConvertionRule:
					"Crea una segunda unidad de medida para su producto posibilitando el movimiento del mismo de diferentes formas en su inventario.",
				warningConvertionRule:
					"La regla de conversión solo puede ser habilitada cuando el producto es controlado por unidad.",
			},
			preparationTime: "Tiempo de preparación",
			preparationTimePlaceholder: "30",
			preparationTimeUnit: "minutos",
		},
		fiscal: {
			code: "SKU",
			codeErrorMessage: "Si no se llena, el código será generado automáticamente",
			ncm: "NCM",
			cest: "CEST",
			fiscalProfile: "Perfil fiscal",
			fiscalGroup: "Grupo fiscal",
			hasIcmsRetidoOptions: {
				yes: "Sim, possui ICMS pago anteriormente por ST",
				no: "Não, não possui ICMS pago anteriormente por ST",
			},
			fiscalIcmsBaseCalculoRetSt: "Base de Cálculo do ICMS Retido na operação anterior",
			fiscalIcmsValorSubistituto: "Valor do ICMS Próprio do Substituto",
			fiscalIcmsAliquotaFinal: "Alíquota Suportada pelo Consumidor Final",
		},
		mountable: {
			step: "Etapa",
			addStep: "Agregar Etapa",
			infos: {
				label: "Informaciones",
				title: "Título",
				titleErrorMessage: "Nombre inválido",
				precification: "Precio",
				precificationErrorMessage: "Elija un método",
				precificationSelect: {
					label: "Elija...",
					sum: "Adicional",
					sumTooltip: "Todo elemento agregado será incrementado en el valor del producto",
					average: "Promedio",
					averageTooltip: "El promedio de los elementos seleccionados será incrementado",
					higher: "Mayor valor",
					higherTooltip:
						"El mayor valor entre los elementos será agregado al valor del producto",
				},
				min: "Mín",
				tooltipMin: "Mínimo de elementos a ser seleccionado.",
				max: "Máx",
				tooltipMax: "Máximo de elementos a ser seleccionado.",
				invalidValue: "Valor inválido",
				validateMaxMinErrors: {
					maxValueZero: "El valor máximo no puede ser igual a cero",
					negativeValue: "No se permite valor negativo",
					maxBiggerThenMin: "Valor máximo debe ser mayor que el valor mínimo",
				},
			},
			items: {
				label: "Elementos",
				title: "Elemento",
				titleErrorMessage: "Ningún elemento seleccionado",
				itemDuplicateError:
					"Este elemento ya ha sido agregado en esta etapa. No es posible agregar el mismo elemento dos veces en la misma etapa.",
				value: "Valor",
				valueErrorMessage: "Valor adicional inválido",
				maxQuantity: "Cantidad máx seleccionable",
				maxQuantityTooltip:
					"Cantidad máxima de veces que este elemento puede ser seleccionado en la sección",
				storageCount: "Cantidad descontada",
				storageCountErrorMessage: "Cantidad inválida",
				storageCountTooltip: "Cantidad que será descontada del inventario por unidad.",
				additionalItems: "Agregar otro elemento",
				itemKey: "Elemento {{itemKey}}",
				modificationItem: "Elemento de modificación",
			},
			information: "INFORMACIONES",
			itemsTitle: "ELEMENTOS",
			getTitleDialog: {
				disable: "Desactivar elemento montable",
				activate: "Activar elemento montable",
			},
			getDescriptionDialog: {
				disable:
					"¿Desea desactivar este elemento en los demás productos montables que lo componen?",
				activate:
					"¿Desea activar este elemento en los demás productos montables que lo componen?",
			},
		},
		productRule: {
			generatedQuantity: "Cantidad Generada",
			input: "Producto/Insumo",
			selectInput: "Selecciona el insumo",
			quantity: "Cantidad",
			loss: "Pérdida",
			addInput: "Agregar insumo",
			addAnotherInput: "Agregar otro insumo",
		},
		proportionalValue: {
			measurement: "Unidad mensurable",
			quantity: "Cantidad",
			grams: "Gramos",
			mililiters: "Mililitros",
		},
	},
	cancelButton: "Cancelar",
	confirmButton: "Confirmar",
	undefined: "indefinido",
};
